const warnCodeDic: any = {
    '001':'이미 사용중인 항목은 삭제 할 수  없습니다.',
    '002':'이미 사용중인 코드는 초기화 할 수 없습니다.',

}

export default warnCodeDic;
